import React from 'react';

// Vague 113 / Wave 1u4 — drag-to-resize divider with hover dots.
export default function EmailResizeHandle({ active, onMouseDown, onDoubleClick, testId }) {
  return (
    <div
      onMouseDown={onMouseDown}
      onDoubleClick={onDoubleClick}
      data-testid={testId}
      title="Glisser pour redimensionner (double-clic = réinitialiser)"
      className={`group w-1.5 cursor-col-resize relative flex-shrink-0 ${active ? 'bg-[#4F46E5]' : 'bg-[#EFF0F6] hover:bg-[#C7D2FE]'}`}
    >
      <span className="absolute -left-2 -right-2 top-0 bottom-0 cursor-col-resize" />
      <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        <span className="w-0.5 h-0.5 rounded-full bg-white" />
        <span className="w-0.5 h-0.5 rounded-full bg-white" />
        <span className="w-0.5 h-0.5 rounded-full bg-white" />
      </span>
    </div>
  );
}
